<template>
    <form @submit="submit_form">
        <!-- Title -->
        <div class="mb-3">
            <h2 class="h5 mb-0">Tags Favoris</h2>
        </div>
        <!-- End Title -->

        <div class="mb-6">
            <!-- Tags Input -->
            <div class="u-tagsinput">
                <input ref="tagsInput" v-bind:value="favoriteTagsNamesInitial" type="text"
                       data-role="tagsinput">
            </div>
            <!-- End Tags Input -->
        </div>

        <!-- Buttons -->
        <LoadingButton v-if="isRequestLoading"/>
        <button v-else type="submit" class="btn btn-sm btn-primary transition-3d-hover mr-1">Enregistrer</button>
        <!-- End Buttons -->
    </form>
</template>

<script>
    import { TagManager } from "../managers";
    import { UPDATE_FAVORITE_TAGS } from "../settings/graphql";
    import {mapMutations} from "vuex";
    import LoadingButton from "./LoadingButton";

    export default {
        name: "FavoriteTagsForm",
        components: {LoadingButton},
        data() {
            return {
                favoriteTagsNamesInitial: TagManager.getNames(this.$store.state.user.info.tagFavoriteSet),
                isRequestLoading: false
            }
        },
        methods: {
            ...mapMutations([
                'setUserInfo'
            ]),
            storeUserInfo(info) {
                this.setUserInfo(info);
            },
            submit_form: function (event) {
                event.preventDefault();
                this.$data.isRequestLoading = true;
                const favoriteTagsNames = this.$refs.tagsInput.value.split(",");
                // console.log(`Updating favorite tags: ${favoriteTagsNames}`);
                this.$apollo.mutate({
                    mutation: UPDATE_FAVORITE_TAGS,
                    variables: {tags: favoriteTagsNames}
                }).then((result) => {
                    this.$data.isRequestLoading = false;
                    // console.log(result.data);
                    this.storeUserInfo(result.data.updatedUser.user);
                    this.$router.push({'name': 'viewProfile', 'params': {'username': this.$store.state.user.info.username}})
                }).catch(() => {
                    this.$data.isRequestLoading = false;
                    // console.error(`We encountered error ${error} on favorite tags updating...`);
                });
            }
        }
    }
</script>

<style scoped>

</style>